<div class="toolbar">
    <ng-container *ngFor="let a of toolbarConfig?.toolbarActions">

        <button *ngIf="a.actType === 'BTN'" [title]="a.actionName | transloco" mat-icon-button [title]="a.actTooltip | transloco"
            [hidden]="!a.actVisible" [class]="a.actCssClass" class="toolbar-button mr-5"
            (click)="executeAction(a.actAction, a)">
            <mat-icon [svgIcon]="a.actionIcon"></mat-icon>
            <span>{{a.actionName | transloco}}</span>
        </button>

        <ng-container *ngIf="a.actType === 'DRP'">
            <mat-icon [svgIcon]="a.actionIcon" [title]="a.actionName | transloco" class="drp-icon"  *ngIf="a.actVisible" ></mat-icon>
            <kendo-dropdownlist class="k-dropdown" [data]="a.dropdownData || []" [value]="a.selectedValue"  [hidden]="!a.actVisible"
                textField="name" valueField="code" [valuePrimitive]="true"
                (valueChange)="executeAction(a.actAction, $event)">
            </kendo-dropdownlist>
        </ng-container>

        <ng-container *ngIf="a.actType === 'TXB'">
            <kendo-textbox [style.width.px]="250" [placeholder]="a.actionName | transloco" [clearButton]="true"
                (keyup)="onChange($event, a)" [(ngModel)]="valueInput[a.actionCode]" class="txb-search" [hidden]="!a.actVisible"> 
                <ng-template kendoTextBoxPrefixTemplate>
                    <mat-icon [svgIcon]="a.actionIcon" [title]="a.actionName | transloco" class="drp-icon"></mat-icon>
                </ng-template>
            </kendo-textbox>

        </ng-container>

        <ng-container *ngIf="a.actType === 'ARR'">
            <mat-icon [svgIcon]="a.actionIcon" [title]="a.actionName | transloco" class="drp-icon"  *ngIf="a.actVisible"></mat-icon>
            <kendo-dropdownlist class="k-dropdown" [data]="a.dropdownData || []" [value]="a.selectedValue" [hidden]="!a.actVisible"
                textField="name" valueField="code" [valuePrimitive]="true"
                (valueChange)="executeAction(a.actAction, $event)">
                <ng-template kendoDropDownListValueTemplate let-dataItem>
                    <span [class.placeholder]="!dataItem">
                        {{ dataItem?.name || (a.placeholder || (a.actionName | transloco)) }}
                    </span>
                </ng-template>
            </kendo-dropdownlist>
        </ng-container>


    </ng-container>
    <!-- {{ 'welcome-back' | transloco }} -->
</div>